module.exports = __webpack_public_path__ + "static/media/socialOverlay7.109bebf6.png";